import { State } from "./state";

export const getAppSettings = (state: State) => state.connectivity.app_settings;
